// convenience wrapper for Hudl services that provides curried AJAX methods﻿
'use strict';

var _ = require('underscore');
var AjaxController = require('./xhr');
var embed = require('./embedded-data');

function Service(urlFormat, data, xhr) {
  // TODO: remove the need for this binding (extend from AjaxController maybe?)
  var instance = this;
  var services = embed.services;
  var prop;
  var serviceUrl;

  if (services && services.hasOwnProperty(urlFormat)) {
    // we got a service name not a url
    urlFormat = services[urlFormat];
  }
  if (data) {
    // format the url using the data object property values
    for (prop in data) {
      if (data.hasOwnProperty(prop)) {
        urlFormat = urlFormat.replace('{' + prop + '}', data[prop]);
      }
    }
  }

  serviceUrl = this._serviceUrl = urlFormat;

  xhr = xhr || AjaxController.instance;
  ['get', 'put', 'post', 'delete', 'patch'].forEach(function(method) {
    // this creates a new method where the first argument is already specified.
    instance[method] = xhr[method].bind(xhr, serviceUrl);
  });
}

_.extend(Service.prototype, {
  getUrl: function() {
    return this._serviceUrl;
  }
});

module.exports = Service;
